/**
 * Do not edit directly
 * Generated on Wed, 24 Sep 2025 17:32:29 GMT
 */

module.exports = {
  "borderRadius": {
    "100": "2px",
    "200": "4px",
    "300": "8px",
    "400": "12px",
    "500": "16px",
    "600": "20px",
    "700": "24px",
    "800": "28px",
    "900": "32px",
    "pill": "9999px",
    "circle": "50%"
  },
  "breakpoints": {
    "100": "320px",
    "200": "720px",
    "300": "1080px",
    "400": "1280px",
    "500": "1440px",
    "600": "1600px"
  },
  "color": {
    "blue": {
      "100": "#e6eeff",
      "200": "#c8d9ff",
      "300": "#abc6ff",
      "400": "#7da2ff",
      "500": "#364ef7",
      "600": "#0c29d0",
      "700": "#0a1f9c",
      "800": "#0b134a"
    },
    "tiny-blue": {
      "100": "#f3f9ff",
      "200": "#ccdcf8",
      "300": "#9fbef4",
      "400": "#6696ea",
      "500": "#0050dc",
      "600": "#0040b0",
      "700": "#002b76",
      "800": "#002058"
    },
    "coral": {
      "100": "#fdf1ea",
      "200": "#f5cdc6",
      "300": "#eda69b",
      "400": "#e58070",
      "500": "#dd5a45",
      "600": "#ca3b25",
      "700": "#9f2f1d",
      "800": "#49150d"
    },
    "pink": {
      "100": "#fce3eb",
      "200": "#f8d0e1",
      "300": "#f1a4c4",
      "400": "#ea78a7",
      "500": "#e34c8b",
      "600": "#da226e",
      "700": "#821442",
      "800": "#560d2b"
    },
    "orange": {
      "100": "#feede1",
      "200": "#fdcfb0",
      "300": "#fba165",
      "400": "#f36607",
      "500": "#c15106",
      "600": "#a94705",
      "700": "#903c04",
      "800": "#5e2803"
    },
    "green": {
      "100": "#c9ffee",
      "200": "#93f3d4",
      "300": "#0fe39f",
      "400": "#0dc78b",
      "500": "#00865b",
      "600": "#086a4c",
      "700": "#054933",
      "800": "#013021"
    },
    "purple": {
      "100": "#f3deff",
      "200": "#dea5fc",
      "300": "#cb6dfd",
      "400": "#af38ef",
      "500": "#9905e8",
      "600": "#6a00a3",
      "700": "#460469",
      "800": "#360252"
    },
    "red": {
      "100": "#ffeae5",
      "200": "#ffc5b9",
      "300": "#ff9a86",
      "400": "#fb775c",
      "500": "#e64c2d",
      "600": "#d23718",
      "700": "#ab351d",
      "800": "#6e0000"
    },
    "yellow": {
      "100": "#fff3d1",
      "200": "#ffe49b",
      "300": "#ffce4b",
      "400": "#f7bc1c",
      "500": "#edad00",
      "600": "#dda100",
      "700": "#956e07",
      "800": "#6e5001"
    },
    "gray": {
      "100": "#f3f3fc",
      "200": "#d1d1e3",
      "300": "#b6b9d0",
      "400": "#9498b8",
      "500": "#696d8c",
      "600": "#50557c",
      "700": "#414563",
      "800": "#312f4f"
    },
    "warm-gray": {
      "100": "#f5f5f5",
      "200": "#ebebeb",
      "300": "#cfcfcf",
      "400": "#a1a1a1",
      "500": "#807e7e",
      "600": "#616161",
      "700": "#363232",
      "800": "#000000"
    },
    "white": "#ffffff",
    "slate": {
      "100": "#fafafb",
      "200": "#f2f3f6",
      "300": "#e5e8ed",
      "400": "#b2b9c8",
      "500": "#808aa3",
      "600": "#4d5c7e",
      "700": "#001647",
      "800": "#000d29"
    },
    "cyan": {
      "100": "#f1f9f9",
      "200": "#e2f4f4",
      "300": "#bbe7e7",
      "400": "#a4dfdf",
      "500": "#8dd7d7",
      "600": "#4abfbf",
      "700": "#359797",
      "800": "#256a6a"
    },
    "beige": {
      "100": "#fcfcfa",
      "200": "#fbfaf8",
      "300": "#f9f7f3",
      "400": "#f6f5ef",
      "500": "#f2f0e8",
      "600": "#dad4be",
      "700": "#b5a87d",
      "800": "#82744a"
    }
  },
  "fontFamily": {
    "soleil": "soleil",
    "poppins": "Poppins",
    "jakarta": "Plus Jakarta Sans"
  },
  "fontSize": {
    "100": "11px",
    "200": "12px",
    "300": "13px",
    "400": "14px",
    "500": "15px",
    "600": "16px",
    "700": "17px",
    "800": "18px",
    "900": "20px",
    "1000": "22px",
    "1100": "24px",
    "1200": "26px",
    "1300": "28px",
    "1400": "30px",
    "1500": "32px",
    "1600": "40px",
    "1650": "44px",
    "1700": "48px",
    "1800": "56px",
    "1900": "64px",
    "2000": "72px",
    "2100": "80px",
    "2200": "88px",
    "2300": "96px"
  },
  "fontWeight": {
    "50": "300",
    "100": "400",
    "150": "500",
    "200": "600",
    "300": "700",
    "400": "800"
  },
  "letterSpacing": {
    "100": "0px",
    "150": "1px",
    "200": "2px"
  },
  "lineHeight": {
    "100": "12px",
    "200": "14px",
    "300": "16px",
    "400": "20px",
    "500": "24px",
    "600": "28px",
    "700": "32px",
    "800": "36px",
    "900": "40px",
    "1000": "44px",
    "1100": "48px",
    "1200": "52px",
    "1300": "56px",
    "1400": "60px",
    "1500": "64px",
    "1600": "68px",
    "1700": "72px",
    "1800": "76px",
    "1900": "80px",
    "2000": "88px",
    "2100": "96px",
    "2200": "104px"
  },
  "opacity": {
    "100": "0.05",
    "200": "0.1",
    "300": "0.2",
    "400": "0.4",
    "500": "0.8"
  },
  "shadow": {
    "blur": {
      "100": "4px",
      "200": "8px",
      "300": "16px",
      "400": "32px",
      "500": "64px"
    },
    "color": {
      "light": "#0b134a",
      "dark": "#010207"
    },
    "opacity": {
      "100": "0.04",
      "200": "0.06",
      "300": "0.08",
      "400": "0.1",
      "500": "0.12",
      "600": "0.16",
      "700": "0.24",
      "800": "0.32"
    },
    "position": {
      "0": "0px 0px",
      "100": "0px 2px",
      "200": "0px 4px",
      "300": "0px 8px",
      "400": "0px 16px",
      "500": "0px 32px",
      "600": "0px 64px"
    }
  },
  "spacing": {
    "0": "0px",
    "100": "2px",
    "200": "4px",
    "300": "8px",
    "400": "12px",
    "500": "16px",
    "600": "24px",
    "700": "32px",
    "800": "40px",
    "900": "48px",
    "1000": "56px",
    "1100": "64px",
    "1200": "80px",
    "1300": "96px",
    "1400": "112px",
    "1500": "128px",
    "1600": "144px",
    "1700": "160px",
    "1800": "176px",
    "1900": "192px",
    "2000": "208px",
    "2100": "224px",
    "2200": "240px",
    "2300": "256px"
  }
};